import React from 'react';
import './NavbarButton.css';

interface NavbarButtonProps {
  icon: React.ReactNode;
  filledIcon: React.ReactNode;
  text: string;
  isSelected: boolean;
  onClick: () => void;
}

const NavbarButton: React.FC<NavbarButtonProps> = ({ icon, filledIcon, text, isSelected, onClick }) => {
  return (
    <button className={`navbar-button ${isSelected ? 'selected' : ''}`} onClick={onClick}>
      {isSelected ? filledIcon : icon}
      <span>{text}</span>
    </button>
  );
};

export default NavbarButton;